import React, { Component } from "react";
import cookie from "react-cookies";

class Logout extends Component {
  LoginType;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    cookie.remove("accessToken", { path: "/" });
    cookie.remove("name", { path: "/" });
    cookie.remove("userID", { path: "/" });
    cookie.remove("userModule", { path: "/" });
    cookie.remove("userType", { path: "/" });
    this.props.history.push("/");
  }
  render() {
    return <h1 className="loading-text">Logging out...</h1>;
  }
}

export default Logout;
